import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ButtonConfirm } from "./Buttons/ButtonConfirm";
import { useAppContext } from "../../AppProvider";
import API from "../../helpers/API";
import { ZplViewer as ZplViewerType } from "../../Models/ZplViewer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader, faSpinner } from "../../utilities/fontawesomeIcons";

const api = new API();

const ZPLViewer: React.FC<ZplViewerType> = ({
  url,
  ddtEnabled = true,
  shipmentId,
  setDdtEnabled,
  checked = false,
}) => {
  const { dictionary } = useAppContext();
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string>("");

  const generateLabel = async (zplCode: string) => {
    if (ddtEnabled) {
      zplCode = zplCode.replaceAll(
        "^PQ1,0,1,Y^XZ",
        `^FO330,690^BQN,2,5
        ^FDLA,https://${api.getURL()}/shipments/ddt/${shipmentId}^FS 

        ^CFA,18
        ^FO30,830^FB800,1,0,C,0
        ^FD eDDT - Documento di trasporto elettronico ^FS
        ...resto del ZPL...
        ^PQ1,0,1,Y
        ^XZ`,
      );
    }

    try {
      const response = await fetch(
        `https://api.labelary.com/v1/printers/8dpmm/labels/4x6/`,
        {
          method: "POST",
          body: zplCode,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            accept: "application/pdf",
          },
        },
      );

      if (!response.ok) {
        toast.error(`Errore durante la conversione del file ZPL`, {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      const blob = await response.blob();
      setPdfBlob(blob);

      const url =
        URL.createObjectURL(blob) +
        "#toolbar=0&navpanes=0&scrollbar=0&view=Fit&zoom=100";
      setPdfBlobUrl(url);
    } catch (error) {
      toast.error(`Errore durante la conversione del file ZPL`, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(() => {
    if (!url) return;

    const fetchData = async () => {
      try {
        const response = await fetch(encodeURIComponent(url));
        if (!response.ok) {
          toast.error(`Errore durante il recupero del file`, {
            position: toast.POSITION.TOP_CENTER,
          });
          return;
        }
        const content = await response.text();
        generateLabel(content);
      } catch (error) {
        toast.error(`Errore durante il recupero del file`, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    };

    fetchData();
  }, [url, ddtEnabled]);

  const handleOpenPdfInNewTab = () => {
    if (pdfBlob) {
      const blobUrl = URL.createObjectURL(pdfBlob);
      window.open(blobUrl, "_blank");
    }
  };

  return (
    <div>
      {pdfBlobUrl ? (
        <div>
          <iframe
            src={pdfBlobUrl}
            height="275px"
            width="100%"
            title="Anteprima PDF"
          />

          {setDdtEnabled && checked && (
            <label className="checkbox my-3">
              <input
                type="checkbox"
                checked={ddtEnabled}
                onChange={() => setDdtEnabled(!ddtEnabled)}
              />
              <span className="checkmark cursor-pointer"></span>
              <span className="span-1">
                {dictionary.actions.add_ddt_to_the_label}
              </span>
            </label>
          )}

          <ButtonConfirm
            icon={false}
            className="w-100 d-flex align-items-center gap-2"
            onClick={handleOpenPdfInNewTab}
          >
            {dictionary.words.open} PDF
          </ButtonConfirm>
        </div>
      ) : (
        <FontAwesomeIcon icon={faLoader} spin />
      )}
    </div>
  );
};

export default ZPLViewer;
